import { Config } from '@/config/types';

export const getLocale = (config: Config) =>
  config.locale || config.defaultLocale;
